import { Component, OnInit} from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../_services/langhfre.service';


@Component({
  selector: 'app-windows-desktop-app',
  templateUrl: './windows-desktop-app.component.html',
  styleUrls: ['./windows-desktop-app.component.scss']
})
export class WindowsDesktopAppComponent implements OnInit {

  downloadLink: string = '';
  downloadLinkText: string = '';

 constructor(
     private titleService: Title,
     private metaTagService: Meta,
     private LinkService: LinkService
 
   ) { }

  ngOnInit(): void {
    this.titleService.setTitle('免費桌面文法檢查應用程式－Trinka Windows 應用程式');
    this.metaTagService.updateTag({ name: 'description', content: '使用 Trinka Windows 版，無論您在各種 Windows 軟體中撰寫內容，都能即時獲得專業的文法修正與建議。' });
    this.metaTagService.updateTag({ property: 'og:title', content: '免費桌面文法檢查應用程式－Trinka Windows 應用程式' });
    this.metaTagService.updateTag({ property: 'og:description', content: '使用 Trinka Windows 版，無論您在各種 Windows 軟體中撰寫內容，都能即時獲得專業的文法修正與建議。' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/tw/windows-desktop-app' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: '免費桌面文法檢查應用程式－Trinka Windows 應用程式' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "使用 Trinka Windows 版，無論您在各種 Windows 軟體中撰寫內容，都能即時獲得專業的文法修正與建議。" });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ name: 'language', content: 'en-us' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/tw/windows-desktop-app' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/windows-desktop-app' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/windows-desktop-app' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/windows-desktop-app' });

    if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
      this.setDownloadLink();
    }
  }

  setDownloadLink(): void {
    if (navigator.userAgent.indexOf("WOW64") != -1 || navigator.userAgent.indexOf("Win64") != -1) {
      this.downloadLink = '<a class="filled-btn" href="https://s3.amazonaws.com/trinka-win-native/64bit/TrinkaForWindows.msi" target="_blank"><img src="/assets/images/download.svg" alt="whitepaper"> 立即下載</a>';
      this.downloadLinkText = '<a href="https://s3.amazonaws.com/trinka-win-native/64bit/TrinkaForWindows.msi" target="_blank" class="text-link">download</a>';
    } else {
      this.downloadLink = '<a class="filled-btn" href="https://s3.amazonaws.com/trinka-win-native/32bit/TrinkaForWindows.msi" target="_blank"><img src="/assets/images/download.svg" alt="whitepaper"> 立即下載</a>';
      this.downloadLinkText = '<a href="https://s3.amazonaws.com/trinka-win-native/32bit/TrinkaForWindows.msi" target="_blank" class="text-link">download</a>';
    }
  }


  stopAllVideos() {
    const iframes = Array.from(document.querySelectorAll('iframe.youtubeVideoForTryDemo'));
    iframes.forEach((iframe) => {
        const htmlIframe = iframe as HTMLIFrameElement;
        htmlIframe.src = htmlIframe.src;
    });
  }
  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }

}
